<img src="data:image/png;base64, R0lGODlhAQABAIAAAMLCwgAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="
     srcset="assets/{{ pathBasedOnType }}/{{ name }}.{{ type }}"
     class="{{ classes }}"
     [alt]="alt"
     [title]="title"
     decoding="async"
     loading="lazy"
     [width]="width"
     [height]="height">
